module.exports = __webpack_public_path__ + "media/assets/images/marker-owner-8be440cea71344efce1a84f816c90807.svg";